import { type ReactNode, type PropsWithChildren } from "react";

import { cn } from "~/lib/utils";

type ReportCardProps = PropsWithChildren<{
  title: ReactNode;
  className?: string;
}>;

export const ReportCard = ({ title, children, className }: ReportCardProps) => (
  <div className={cn("flex flex-col gap-2", className)}>
    <h3 className="text-base font-bold text-text-primary">{title}</h3>
    <div className="overflow-hidden rounded-xl bg-white">{children}</div>
  </div>
);
